import React from 'react';
import i18n from 'i18n';
import { Col, FormGroup } from 'reactstrap';
import { Select } from 'antd';
import PropTypes from 'prop-types';

import { FieldInfo, FieldError, Label } from 'components/common/inputs';

const MultiSelectLabel = ({
	input,
	id,
	label,
	required,
	placeholder,
	labelColumn,
	inputColumn,
	isEditDisabled,
	mode,
	showSearch,
	children,
	meta: { touched, error, submitError },
	onSearch,
	fieldInfo,
	onChangeCallback,
	dropdownStyle,
	...otherProps
}) => {
	const handleOnChange = (event) => {
		input.onChange(event);
		onChangeCallback(event);
	};
	return (
		<FormGroup row className={`${touched && error && 'has-error'} form-group`}>
			{isEditDisabled && <div className="form-group__disabled">&nbsp;</div>}
			<Label
				id={id}
				columnWidth={labelColumn}
				required={required}
				content={label}
			/>
			<Col sm={inputColumn}>
				<Select
					{...input}
					showSearch
					value={input.value || []}
					mode={mode}
					style={{ width: '100%' }}
					placeholder={placeholder}
					className="m-b-sm"
					onSearch={onSearch}
					dropdownStyle={dropdownStyle}
					onChange={handleOnChange}
					{...otherProps}
				>
					{children}
				</Select>
				<FieldError
					error={touched && (error || submitError)}
					inputName={input.name}
					content={error || submitError}
				/>
				<FieldInfo info={fieldInfo} />
			</Col>
		</FormGroup>
	);
};

MultiSelectLabel.defaultProps = {
	onSearch: () => {},
	onChangeCallback: () => {},
	showSearch: false,
	mode: 'multiple',
	labelColumn: 2,
	inputColumn: 10,
	placeholder: i18n.t('inputs:defaults.multiselectcustomchange'),
	isEditDisabled: false
};

MultiSelectLabel.propTypes = {
	input: PropTypes.object,
	id: PropTypes.string,
	label: PropTypes.string,
	required: PropTypes.bool,
	placeholder: PropTypes.string,
	labelColumn: PropTypes.number,
	inputColumn: PropTypes.number,
	isEditDisabled: PropTypes.bool,
	mode: PropTypes.string,
	children: PropTypes.array,
	meta: PropTypes.object,
	onSearch: PropTypes.func,
	otherProps: PropTypes.object,
	showSearch: PropTypes.bool,
	fieldInfo: PropTypes.string,
	requiredField: PropTypes.bool
};

export default MultiSelectLabel;
